const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/components/context.ts';
import { createContext, RefObject } from 'react';
import { TextFieldVariants } from '@mui/material/TextField/TextField';
import { FormRef } from '../defs';
import { KeyValuePair } from '../../../defs/generalDefs';

export type FormContextType = {
    dataRef: RefObject<KeyValuePair | null>;
    formRef: RefObject<FormRef | undefined | null>;
    style: {
        variant: TextFieldVariants;
    };
};

export const FormContext = createContext<FormContextType | undefined>(undefined);